const Routing = () => (next) => (action) => {
  const result = next(action)
  return result
}

export default Routing
